// extracted by mini-css-extract-plugin
export default {"root":"HeaderCell_root__ofRYb","grouping":"HeaderCell_grouping__iZwgJ"};